import React, { Component } from 'react';
import {Button} from '@betareader/design-system';
import { withTranslation } from 'react-i18next';

export class GenderGetter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      gender: props.initialValue || null
    };
  }

  getGenderOptions = () => {
    const { t } = this.props;
    const genderOptions = [
      {
        key: 'm',
        value: 'm',
        text: t('male')
      },
      {
        key: 'f',
        value: 'f',
        text: t('female')
      },
      {
        key: 'o',
        value: 'o',
        text: t('other')
      },
      {
        key: 'na',
        value: 'na',
        text: t('DontWantToShare')
      }
    ];
    return genderOptions;
  }

  handleChange = event => {
    const { wizardMode } = this.props;
    this.setState({ gender: event.target.value || null }, () => {
      if (wizardMode && this.state.gender !== null) {
        this.submit();
      }
    });
  }

  submit = () => {
    const { gender } = this.state;
    if (this.props.onUpdate) {
      this.props.onUpdate({ gender });
    }
  }

  // render
  render() {
    const { t, updating, wizardMode } = this.props;
    const { gender } = this.state;
    return (
      <div>
        <h2>{t('Gender')}</h2>
        <p>{t('OnYourProfile')}</p>
        <label className='br-field'>
          <span className='br-field__label'>{t('Gender')}</span>
          <select className='br-field__input' value={gender ?? ''}
            onChange={this.handleChange}>
            <option value=''>{t('Gender')}</option>
            {this.getGenderOptions().map(option => (
              <option key={option.key} value={option.value}>{option.text}</option>
            ))}
          </select>
        </label>
        <Button style={{marginTop: '1em'}} onClick={this.submit}
          disabled={updating} aria-busy={updating}>
          {wizardMode ? (gender === null ? t('Skip') : t('Next')) : t('Save')}
        </Button>
      </div>
    );
  }
}

export default withTranslation()(GenderGetter);
